import React from 'react';
import styled from 'styled-components';

const Checkbox = ({onChange, model, checked, checkboxStyle, ...props}) => {
  return (
    <Container {...props}>
      {model.label}
      <input 
        type="checkbox" 
        checked={checked}
        onChange={event => onChange(event.target.checked, model)}
      />
      <span style={checkboxStyle} />
    </Container>
  );
};

const Container = styled.label`
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 14px;
  user-select: none;
  border-radius: 4px;

  & > input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
    border-radius: 4px;
  }

  & > span {
    position: absolute;
    top: 0;
    left: 0;
    height: 24px;
    width: 24px;
    background-color: #eee;
    border-radius: 4px;

    &:after {
      content: "";
      position: absolute;
      display: none;
      left: 8px;
      top: 3px;
      width: 9px;
      height: 14px;
      border: solid white;
      border-width: 0 3px 3px 0;
      transform: rotate(45deg);
    }
  }

  &:hover input ~ span {
    background-color: #ccc;
  }

  & > input:checked ~ span {
    background-color: #2E83FF;
  }

  & > input:checked ~ span:after {
    display: block;
  }
  
  ${props => props.styled || ''}
`;

export {
  Checkbox,
};